import {
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import Checkbox from 'ext-ui/components/Checkbox/Checkbox'
import React from 'react'
import { useTranslate } from 'src/localization/Trns'
import { TransactionReceiptRecoveryStatus } from 'src/models/transaction.models'
import { css } from 'styled-components'

interface TransactionReceiptRecoveryStatusFilterProps {
  receiptRecoveryStatusSet: Set<string>
  handleReceiptRecoveryStatusSelection: (status: string) => Set<string>
}

const receiptRecoveryStatusOptions = [
  {
    id: 'receipt-recovery-status-needs-review',
    label: 'Needs Review',
    value: TransactionReceiptRecoveryStatus.NeedsReview,
  },
  {
    id: 'receipt-recovery-status-waiting-on-spender',
    label: 'Waiting on Spender',
    value: TransactionReceiptRecoveryStatus.WaitingOnSpender,
  },
  {
    id: 'receipt-recovery-status-reconciled',
    label: 'Receipt Reconciled',
    value: TransactionReceiptRecoveryStatus.ReceiptReconciled,
  },
] as const

const TransactionReceiptRecoveryStatusFilter: React.FC<
  TransactionReceiptRecoveryStatusFilterProps
> = ({ receiptRecoveryStatusSet, handleReceiptRecoveryStatusSelection }) => {
  const translate = useTranslate()

  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        gap: 12px;
      `}
    >
      <div
        css={css`
          ${getFontCss(
            14,
            themeConstants.colors.font_primary,
            styleConstants.fontFamilies.medium,
          )};
        `}
      >
        {translate('Receipt Recovery Status')}
      </div>
      {receiptRecoveryStatusOptions.map((option) => (
        <div className="flex-row align-center gap-2" key={option.value}>
          <Checkbox
            id={option.id}
            checked={receiptRecoveryStatusSet.has(option.value)}
            aria-label={translate(option.label)}
            onChange={(): void => {
              handleReceiptRecoveryStatusSelection(option.value)
            }}
          />
          <label
            htmlFor={option.id}
            css={css`
              ${getFontCss(
                14,
                themeConstants.colors.font_primary,
                styleConstants.fontFamilies.regular,
              )};
              cursor: pointer;
            `}
          >
            {translate(option.label)}
          </label>
        </div>
      ))}
    </div>
  )
}

export default TransactionReceiptRecoveryStatusFilter
